import { Builder } from 'builder-pattern';
import { create } from 'zustand';
import { loadingStore } from '@modules/core/adapter/outbound/stores/ui.store';
import { filterStore } from '@modules/filter/adapter/outbound/stores/filter.store';
import { GetSearchResultUsecase } from '@modules/search/application/usecases/getSearchResult.usecase';
import { IModuleResult, ISearchResult } from '@modules/search/domain/models/searchResult.model';
import { handleAnalyticsSearchResult } from '@shared/helpers/analyticsSearchResult.helper';
import { ModuleType } from '@shared/types/module.type';
import { analytics } from '@shared/utils/segment.utils';
import { SearchResultRepositoryImpl } from '../../inbound/repositories/searchResult.repository';
interface SearchResultParams {
  keyword: string;
  currentPage: number;
  pageSize: number;
  isSearchNewKeyword: boolean;
}
interface SearchResultState {
  totalProducts: number;
  totalRecipes: number;
  totalTipsTricks: number;
  searchProducts: IModuleResult;
  searchRecipes: IModuleResult;
  searchTipsTricks: IModuleResult;
  setSearchProducts: (searchResultParams: SearchResultParams) => Promise<void>;
  setSearchRecipes: (searchResultParams: SearchResultParams) => Promise<void>;
  setSearchTipsTricks: (searchResultParams: SearchResultParams) => Promise<void>;
  resetData: () => void;
}
const initialState = Builder<IModuleResult>().data([]).currentPage(1).canLoadMore(true).build();
export const searchResultStore = create<SearchResultState>((set, get) => ({
  totalProducts: 0,
  totalRecipes: 0,
  totalTipsTricks: 0,
  searchProducts: initialState,
  searchRecipes: initialState,
  searchTipsTricks: initialState,
  resetData: () => {
    set(() => ({
      totalProducts: 0,
      totalRecipes: 0,
      totalTipsTricks: 0,
      searchProducts: initialState,
      searchRecipes: initialState,
      searchTipsTricks: initialState
    }));
  },
  setSearchProducts: async ({
    keyword,
    currentPage,
    pageSize,
    isSearchNewKeyword
  }: SearchResultParams) => {
    try {
      loadingStore.setState({
        isLoading: true
      });
      const selectedRecipeFilters = filterStore.getState().selectedRecipeCategoryItem;
      const selectedProductFilters = filterStore.getState().selectedProductCategoryItem;
      const selectedTipsTricksFilters = filterStore.getState().selectedTipsTricksCategoryItem;
      const prevData = isSearchNewKeyword ? [] : get().searchProducts.data ?? [];
      const searchResultRepositoryImpl = new SearchResultRepositoryImpl();
      const getSearchResultUsecase = new GetSearchResultUsecase(searchResultRepositoryImpl);
      const result = await getSearchResultUsecase.handle(keyword, ModuleType.Product, currentPage, pageSize, prevData, selectedRecipeFilters, selectedProductFilters, selectedTipsTricksFilters);
      if (result.isRight()) {
        const {
          data,
          totalProducts,
          totalRecipes,
          totalTipsTricks
        }: ISearchResult = result.value;
        handleAnalyticsSearchResult(keyword, ModuleType.Product, totalProducts);
        set(() => ({
          searchProducts: data,
          totalProducts,
          totalRecipes,
          totalTipsTricks
        }));
      }
    } catch (error) {
      console.error('error setSearchProducts ', error);
    } finally {
      loadingStore.setState({
        isLoading: false
      });
    }
  },
  setSearchRecipes: async ({
    keyword,
    currentPage,
    pageSize,
    isSearchNewKeyword
  }: SearchResultParams) => {
    try {
      loadingStore.setState({
        isLoading: true
      });
      const selectedRecipeFilters = filterStore.getState().selectedRecipeCategoryItem;
      const selectedProductFilters = filterStore.getState().selectedProductCategoryItem;
      const selectedTipsTricksFilters = filterStore.getState().selectedTipsTricksCategoryItem;
      const prevData = isSearchNewKeyword ? [] : get().searchRecipes.data ?? [];
      const searchResultRepositoryImpl = new SearchResultRepositoryImpl();
      const getSearchResultUsecase = new GetSearchResultUsecase(searchResultRepositoryImpl);
      const result = await getSearchResultUsecase.handle(keyword, ModuleType.Recipe, currentPage, pageSize, prevData, selectedRecipeFilters, selectedProductFilters, selectedTipsTricksFilters);
      if (result.isRight()) {
        const {
          data,
          totalProducts,
          totalRecipes,
          totalTipsTricks
        }: ISearchResult = result.value;
        handleAnalyticsSearchResult(keyword, ModuleType.Recipe, totalRecipes);
        set(() => ({
          searchRecipes: data,
          totalProducts,
          totalRecipes,
          totalTipsTricks
        }));
      }
    } catch (error) {
      console.error('error setSearchRecipes ', error);
    } finally {
      loadingStore.setState({
        isLoading: false
      });
    }
  },
  setSearchTipsTricks: async ({
    keyword,
    currentPage,
    pageSize,
    isSearchNewKeyword
  }: SearchResultParams) => {
    try {
      loadingStore.setState({
        isLoading: true
      });
      const selectedRecipeFilters = filterStore.getState().selectedRecipeCategoryItem;
      const selectedProductFilters = filterStore.getState().selectedProductCategoryItem;
      const selectedTipsTricksFilters = filterStore.getState().selectedTipsTricksCategoryItem;
      const prevData = isSearchNewKeyword ? [] : get().searchTipsTricks.data ?? [];
      const searchResultRepositoryImpl = new SearchResultRepositoryImpl();
      const getSearchResultUsecase = new GetSearchResultUsecase(searchResultRepositoryImpl);
      const result = await getSearchResultUsecase.handle(keyword, ModuleType.TipsTricks, currentPage, pageSize, prevData, selectedRecipeFilters, selectedProductFilters, selectedTipsTricksFilters);
      if (result.isRight()) {
        const {
          data,
          totalProducts,
          totalRecipes,
          totalTipsTricks
        }: ISearchResult = result.value;
        handleAnalyticsSearchResult(keyword, ModuleType.TipsTricks, totalTipsTricks);
        set(() => ({
          searchTipsTricks: data,
          totalProducts,
          totalRecipes,
          totalTipsTricks
        }));
      }
    } catch (error) {
      console.error('error setSearchTipsTricks ', error);
    } finally {
      loadingStore.setState({
        isLoading: false
      });
    }
  }
}));